export function canPatientInitiateNewConversation(patient) {
  return patient?.allowPatientInitiateMessaging === true;
}

export function canPatientViewConversation(conversation, patientId) {
  if (!patientId || !conversation || conversation.isStaffOnly) return false;
  return (
    Array.isArray(conversation.members) &&
    conversation.members.some((member) => member?.kind === "patient" && member.id === patientId)
  );
}

export function canPatientRespondToConversation(conversation, patientId) {
  return (
    Boolean(conversation?.conversationId || conversation?.draftTarget) &&
    canPatientViewConversation(conversation, patientId)
  );
}

export function shouldAdoptCreatedConversation(openConversation, createdConversation) {
  const target = openConversation?.draftTarget;
  if (!openConversation || openConversation.conversationId != null || !target) return false;
  return (
    Array.isArray(createdConversation?.members) &&
    createdConversation.members.some(
      (member) => member?.kind === target.kind && member.id === target.id && member.kind !== "patient"
    )
  );
}
